import { AppEnvironment } from './environment.model'
import { getApiUrls, getIdentityServerConfig } from './environment.utils'
import { EnvType } from '@mediacoach/ui'
import { ENV_COMMON_SETTINGS } from './environment.constants'

// --- Environment-specific Configuration ---
const envType = EnvType.Ts
const bundleId = 'com.sportian.performance.mobile.ts'
const urlScheme = `${bundleId}://`
const clientId = '39f4f70b-c8a2-d3c0-1e1d-d97720429e37'
const appDomain = 'https://mobile-ts.mediacoach.es'
const apiDomain = 'https://mobile-api-ts.mediacoach.es'
const identityServerUrl = 'https://id-ts.mediacoach.es'
const webSocketDomain = 'https://mobile-ws-ts.mediacoach.es'
const staticsUrlCloud = 'https://festatics-ts.performance.sportian.dev'
const portalDownloadUrl = 'https://portal-ts.mediacoach.es/descargas'
const smartlookApiKey = '3df4d8f4170d79ddb97fe2ab39911626944edc75'

export const environment: AppEnvironment = {
  ...ENV_COMMON_SETTINGS,
  bundleId,
  envType,
  smartlookApiKey,
  appDomain,
  apiDomain,
  identityServerUrl,
  staticsUrlCloud,
  portalDownloadUrl,
  urlScheme,
  production: true,
  enableContextMenu: true,
  identityServerConfig: (isNative = false, domain = window.location.origin) =>
    getIdentityServerConfig(identityServerUrl, urlScheme, clientId, isNative, domain),
  api: getApiUrls(apiDomain, identityServerUrl, clientId, webSocketDomain)
}
